import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class InventoryDetailsService {
	public inventory = null;

	constructor(public http: HttpClient) {}
}



// WEBPACK FOOTER //
// ./src/pages/inventory/inventorydetails.service.ts